import gql from 'fake-tag'
import { cache } from 'services'
import { PageBanner } from 'types/contentful'

import DefaultClient from './DefaultClient'

class BannersClient extends DefaultClient {
    constructor() {
        super(cache.keys.BANNERS)
    }

    async getPageBanner(path: string, lang = 'en') {
        const banners = await this.getBanners(lang)
        return banners.find((b) =>
            b.routes.some((route) => {
                const baseRoute = route.endsWith('/') && route !== '/' ? route.slice(0, -1) : route
                return path === baseRoute || path.startsWith(`${baseRoute}/`)
            }),
        )
    }

    async getBanners(lang = 'en'): Promise<PageBanner[]> {
        const locale = this.getLocale(lang)
        const cacheKey = `BANNERS_${locale}`
        const cache = this.cache.get(cacheKey)
        if (cache) return cache

        const graphQuery = gql`
            {
                messageBannerCollection(preview: ${this.isPreview}, where: { website: "Twist" }) {
                    items {
                        routes
                        message: message(locale: "${locale}")
                    }
                }
            }
        `
        try {
            const data = await this.queryGraphQL(graphQuery)
            const banners = data.messageBannerCollection.items
            this.cache.set(cacheKey, banners)

            return banners
        } catch (error) {
            return []
        }
    }
}

export default new BannersClient()
